import React, { PureComponent, Fragment } from 'react';
import { bool, func, string, arrayOf, any } from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import IntlMessages from '../../util/IntlMessages';

class RestrictedRolesRoute extends PureComponent {
  static propTypes = {
    signedIn: bool.isRequired,
    userRoles: arrayOf(string).isRequired,
    allowedRoles: arrayOf(string).isRequired,
    component: any,
    render: func,
    path: string.isRequired,
    exact: bool,
  };

  static defaultProps = {
    component: null,
    render: null,
    exact: false,
  };

  get isAllowed() {
    const { userRoles, allowedRoles } = this.props;

    if (userRoles && userRoles.length && allowedRoles && allowedRoles.length) {
      return !!allowedRoles.find(allowedRole => userRoles.includes(allowedRole));
    }

    return false;
  }

  render() {
    const { component, render, path, exact, signedIn } = this.props;

    if (!signedIn) {
      return <Redirect to="/signin" />;
    }

    const routeElement = component ? (
      <Route path={path} component={component} exact={exact} />
    ) : (
      <Route path={path} render={render} exact={exact} />
    );

    return (
      <Fragment>
        {this.isAllowed ? (
          routeElement
        ) : (
          <div className="not-allowed">
            <h1>
              <IntlMessages id="pages.notAllowed" />
            </h1>
          </div>
        )}
      </Fragment>
    );
  }
}

export default RestrictedRolesRoute;
